import {Injectable} from '@angular/core';
import * as moment from "moment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {BehaviorSubject, Observable} from "rxjs";
import {OktaAuthService} from "@okta/okta-angular";
import {ImpersonateClass} from "../pages/admin/admin-class.model";


@Injectable({
  providedIn: 'root'
})
export class DataService {
  priceHistory;
  customDealsRequestHistory;
  customDealsContractHistory;
  impersonateData = {};
  impersonateRowData: ImpersonateClass;
  userData = {};
  private gasGraphData = new BehaviorSubject<any>(null);
  gasGraphDataListener = this.gasGraphData.asObservable();
  constructor(private http: HttpClient, private  oktaAuth: OktaAuthService) {

  }

  getPriceHistory() {
    return this.priceHistory;
  }
  restPriceGetHistory() {
    let url = environment.apiUrl + "price-history";
    return this.http.get<any>(url).toPromise().then((data) => {
      if ('priceHistory' in data) {
        this.priceHistory = data.priceHistory;
        return this.priceHistory
      } else {
        throw 'Error'
      }
    }).catch((error) => {
      throw error;
    });
  }


  getCustomDealsRequestHistory() {
    return this.customDealsRequestHistory;
  }
  getCustomDealsContractHistory() {
    return this.customDealsContractHistory;
  }
  restCustomDealsRequestHistory() {
    let url = environment.apiUrl + "getcustom-deal-requests";
    return this.http.get<any>(url).toPromise().then((data) => {
      if (Array.isArray(data)) {
        this.customDealsRequestHistory = data ;
        return this.customDealsRequestHistory
      } else {
        throw 'Error'
      }
    }).catch((error) => {
      throw error;
    });
  }
  restCustomDealsContractHistory() {
    let url = environment.apiUrl + "quote-contract-gen/history";
    // let url = './assets/contractHistoryMock.json'
    return this.http.get<any>(url).toPromise().then((data) => {
      if (Array.isArray(data)) {
        this.customDealsContractHistory = data;
        return this.customDealsContractHistory
      } else {
        throw 'Error'
      }
    }).catch((error) => {
      throw error;
    });
  }

  makeCustomDealRequest(requestPayload) {
    // let url = environment.apiUrl + "postcustom-deal-request";
    // return this.http.post<any>(url, requestPayload);
    let url = environment.apiUrl + "putcustom-deal-request";
    return this.http.put<any>(url, requestPayload);
  }

  uploadAttachments(requestPayload) {
    let url = environment.apiUrl + "file/upload/multi";
    return this.http.post<any>(url, requestPayload);
    // return this.http.post<any>(url, requestPayload, {reportProgress: true, observe: 'events'});
  }

  getMarketData(pathParam?: string) {
    let url = environment.apiUrl + `get-price-movement/${pathParam}`;
    // let url = './assets/marketMoves.json'
    return this.http.get<any>(url);
    // return this.http.get<any>(pathParam === 'natgas' ? url: './assets/lineChart.json');
    // return this.http.post<any>(url, requestPayload, {reportProgress: true, observe: 'events'});
  }
  getBrokerInfo() {
    let url = environment.apiUrl + `get-broker`;
    return this.http.get<any>(url);
    // return this.http.post<any>(url, requestPayload, {reportProgress: true, observe: 'events'});
  }

  getBrokerAdminInfo(field: string | number, val: string | number) {
    let url = environment.apiUrl + `broker/${field}/${val}`;
    return this.http.get<any>(url);
  }

  brokerImpersonate(id: string | number) {
    let url = environment.apiUrl + `broker/identifyas/${id}`;
    return this.http.post(url, {}, {responseType: "text"});
  }

  resetBrokerImpersonate() {
    let url = environment.apiUrl + `broker/identifyas/delete`;
    return this.http.post(url, {}, {responseType: "text"});
  }

  setImpersonateDetails(data){
    this.impersonateData = data;
  }

  get ImpersonateData(){
    return this.impersonateData
  }

  setImpersonateRowData(data){
    this.impersonateRowData = data;
  }

  get ImpersonateRowData(){
    return this.impersonateRowData
  }

  getContractTemplateInfo(endpoint) {
    let url = environment.apiUrl + `contract-template-file/${endpoint}`;
    return this.http.get<any>(url);
  }

  uploadContractTemplate(form, file) {
    const {product, state, market} = form;
    let headers = new HttpHeaders();
    headers.append('Content-type', 'multipart/form-data')
    let url = environment.apiUrl + `contract-template-file/upload/${product}/${state}/${market}`;
    return this.http.post(url, file, {responseType: "text", headers: headers});
  }

  getDistinctNodes() {
    let url = environment.apiUrl + `get-price-movement/distinctnodes`;
    return this.http.get(url);
  }

  getUtilities(pathParam: string) {
    let url = environment.apiUrl + `get-utilities/${pathParam}`;
    return this.http.get(url);
  }

  getApiData(pathParam: string, method: string = 'GET', body?: any) {
    let url = environment.apiUrl + pathParam;
    // let url = './assets/statesMock.json'
    if(method === 'GET') {
      return this.http.get(url);
      // return this.http.get(pathParam.indexOf('quickquotes') != -1 ? './assets/utilityValidationRecord.json': './assets/statesMock.json' )
    }else {
      return this.http.post(url, body);
    }
  }
  getApiDataTextResp(pathParam: string, method: string = 'GET', body?: any) {
    let url = environment.apiUrl + pathParam;
    // let url = './assets/statesMock.json'
    if(method === 'GET') {
      return this.http.get(url, {responseType: 'text'});
      // return this.http.get(pathParam.indexOf('quickquotes') != -1 ? './assets/utilityValidationRecord.json': './assets/statesMock.json' )
    }else {
      return this.http.post(url, body,{responseType: 'text'});
    }
  }
}
